$(function () {

  // ------------------------------
  // ヘッダーのINFORMATIONリンク無効化
  // ------------------------------
  $('.site-nav__link--has-dropdown').on('click', function () {
    let text = $(this).text().trim();
    if (text == 'Information') return false;
    else return true;
  });

  // ------------------------------
  // how to の画像モーダル
  // ------------------------------
  $('.howto_item img').on('click', function () {
    let src = $(this).attr('src');
    $('.nana_modal_img img').attr('src', src);
    $('.nana_modal').fadeIn();
  });

  $('.nana_modal_close').on('click', function () {
    $('.nana_modal').fadeOut();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nana_modal_img') && e.target.closest('.nana_modal')) {
      $('.nana_modal').fadeOut();
    }
  });


  // ------------------------------
  // how to のメニュー移動
  // ------------------------------
  $(window).on('load scroll resize', function () {
    if (!$('.howto').length) return;
    let scroll = $('html').scrollTop() || $('body').scrollTop();
    let num = 0;
    $('.howto h2').each(function (idx, elem) {
      let position = $(elem).offset().top - 120;
      if (scroll > position) {
        num = idx;
      }
    });
    $('.howto_menus li').removeClass('active');
    $('.howto_menus li').eq(num).addClass('active');
  });

  $('.howto_menus li').on('click', function () {
    let num = $(this).data('num');
    let target = $('.howto h2').eq(num).offset().top - 110;
    $('html,body').animate({ scrollTop: target }, 500, 'swing');
  });

  // ------------------------------
  // JOURNAL一覧
  // ------------------------------

  $(document).on({
    'mouseenter': function () {
      let hoverImg = $(this).data('hover');
      $(this).attr('src', hoverImg);
    },
    'mouseleave': function () {
      let originalImg = $(this).data('original');
      $(this).attr('src', originalImg);
    }
  }, '.journal_list_products_img');

  // ------------------------------
  // PEOPLE
  // ------------------------------

  $(document).on({
    'mouseenter': function () {
      let src = $(this).attr('src');
      $('#people_imgs_big').attr('src', src);
    },
    'mouseleave': function () {
      //何もしない
    }
  }, '.people_imgs ul img');

  //プロフィール欄のURLにリンク付与
  // let profile = $('.people_profile_info p:last-child').html();

  $(document).on('click', '#people_imgs_big', function () {
    let nowIdx = $(this).data('idx');
    let nextIdx = nowIdx + 1;
    let nextObj = $(this).parents('.people_imgs').find('ul').find('li').eq(nextIdx);
    if (nextObj.length > 0) {
      let src = nextObj.find('img').attr('src');
      $('#people_imgs_big').attr('src', src);
      $(this).data('idx', nextIdx);
    } else {
      let src = $(this).parents('.people_imgs').find('ul').find('li').eq(0).find('img').attr('src');
      $('#people_imgs_big').attr('src', src);
      $(this).data('idx', 0);
    }
  });

  $('.auto-link').each(function (idx, elem) {
    let str = $(elem).html();
    let regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    let regexp_makeLink = function (all, url, h, href) {
      url = url.replace('https://', '');
      url = url.replace('http://', '');
      return '<a href="h' + href + '" target="_blank">' + url + '</a>';
    }
    let textWithLink = str.replace(regexp_url, regexp_makeLink);
    $(elem).html(textWithLink);
  });

  // let regexp = /.*https?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+).*/g;

  // for (const match of profile.matchAll(regexp)) {
  //   let url = match[0];
  //   let index = match.index;
  //   let length = url.length;
  //   console.log(url, index, length);

  // }

  // console.log(array[0]);
  // expected output: Array ["test1", "e", "st1", "1"]

  // console.log(array[1]);
  // expected output: Array ["test2", "e", "st2", "2"]


  // console.log(profile);
  // let url = profile.matchAll();
  // console.log(url);
  // $('.people_profile_info p:last-child').html(profile);

  // ------------------------------
  // HOWTO renewal
  // ------------------------------
  $('.link_in_page').on('click', function () {
    let target = $(this).data('item');
    let position = $(target).offset().top;
    let headerHeight = $('#SiteHeader').outerHeight();
    $('html,body').animate({ scrollTop: position - headerHeight - 50 }, 500, 'swing');

    //スマホのときは消す
    let windowW = $(window).width();
    console.log('windowW: ' + windowW);
    if (windowW <= 768) {
      $('.howto_sidebar').hide();
    }
  });

  $('.howto_sidebar_opener').on('click', function () {
    $('.howto_sidebar').slideToggle(200);
  });
});
